
const Badge = (props) => {
  const positionClasses = `
        ${props.top ? `top-${props.top}` : ""}
        ${props.start ? `start-${props.start}` : ""}
        ${props.end ? `end-${props.end}` : ""}
        ${props.bottom ? `bottom-${props.bottom}` : ""}
      `.trim();

  return (
    <>
      <span
        className={` position-absolute pb-0 p-1  ${positionClasses} translate-middle badge rounded-pill bg-${props.color}`}
        onClick={props.onClick}
        style={{
          top: props.top,
          right: props.end,
          bottom: props.bottom,
          left: props.start,
          transform: "translate(-50%, -50%)",
        }}
      >
        {props.text}
      </span>
    </>
  );
};

export default Badge;

{
  /* <span
        className={`position-absolute top-${top} start-${start} end-${end} bottom-${bottom} translate-middle badge rounded-pill bg-${color}`}
      >
        99+
        <span className="visually-hidden">unread messages</span>
      </span> */
}
